<template>
  <!--支付方式-->
  <el-select v-model="payType" clearable>
    <el-option
      :label="item.dictLabel"
      :value="item.dictValue"
      v-for="(item, index) in payTypeOptions"
      :key="index"
    ></el-option>
  </el-select>
</template>
<script>
import { PAY_TYPE } from "@/constant/dict";
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  computed: {
    payType: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      payTypeOptions: [],
    };
  },
  created() {
    this.getPayTayeDict();
  },
  methods: {
    async getPayTayeDict() {
      const data = await this.$store.dispatch("getDictData", PAY_TYPE);
      this.payTypeOptions = data;
    },
  },
};
</script>
